'use client';

import { useEffect } from 'react';

import './global.css';
import { Callout } from 'fumadocs-ui/components/callout';

import { reportErrorChainToConsole } from '@/shared/browser/error-chain-report';

/**
 * 全局错误边界：使用 fumadocs 官方模板的 Callout 错误样式，
 * 完整错误链由浏览器控制台抛出。根布局抛错时 Next.js 会渲染此文件，
 * html/body 需由本组件自行提供。
 */
export default function GlobalErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportErrorChainToConsole(error);
  }, [error]);

  return (
    <html lang="zh-CN">
      <body>
        <main className="global-error-panel flex min-h-screen flex-col items-center justify-center gap-4 p-8">
          <Callout type="error" title="页面出现错误">
            页面渲染时发生错误，完整错误信息已输出到浏览器控制台。
          </Callout>
          <button
            type="button"
            onClick={() => reset()}
            className="global-error-retry rounded border px-4 py-2 text-sm"
          >
            重试
          </button>
        </main>
      </body>
    </html>
  );
}
